import { RadioButton } from "components/common/RadioButton";
import { Label } from "reactstrap";
import { Nullable } from "util/extendedTypes";

type CustomLabelRadioOptionsProps = {
  name: string;
  title: string;
  option1?: boolean;
  option2?: boolean;
  value?: Nullable<boolean>;
  option1Label?: string;
  option2Label?: string;
  onChange: (v: boolean) => void;
};
export const CustomLabelRadioOptions = ({
  name,
  title,
  option1,
  option2,
  value,
  option1Label,
  option2Label,
  onChange,
}: CustomLabelRadioOptionsProps) => {
  return (
    <fieldset>
      <Label>{title}</Label>
      <div className="customLabelRadios-radios">
        <RadioButton
          name={name}
          label={option1Label ?? "Yes"}
          isSelected={option1 ?? value!}
          onChange={() => onChange(true)}
          disabled={false}
        />
        <RadioButton
          name={name}
          label={option2Label ?? "No"}
          isSelected={option2 ?? value === false}
          onChange={() => onChange(false)}
          disabled={false}
        />
      </div>
    </fieldset>
  );
};
